import { createContext } from 'react'
import { ITheme } from './theme'

export interface IRoutePlanningThemeContext {
  theme: ITheme
}

export const RoutePlanningThemeContext = createContext(
  {} as IRoutePlanningThemeContext,
)
